module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/73.bd4b8833.png";